import React from 'react';

const AboutPage = () => {
  return (
    <section className="about-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="about-page__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
              <div className="about-page__img">
                <img src="assets/images/30.jpg" alt="" />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="about-page__right">
              <div className="section-title text-left sec-title-animation animation-style2" style={{ textAlign: 'left' }}>
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">About Rayyan Aid</span>
                </div>
                <h2 className="section-title__title title-animation">Together, we give hope to <span>vulnerable</span> <span>people</span> and change lives</h2>
              </div>
              <p className="about-page__text" style={{ textAlign: 'left' }}>Rayyan Aid is a non‑profit organization committed to protecting dignity and improving quality of life for families in need. We focus on sustainable impact across education, healthcare, nutrition and emergency relief — working hand‑in‑hand with local communities to deliver the right help at the right time.</p>
              <ul className="about-page__points list-unstyled">
                <li>
                  <div className="about-page__points-content">
                    <div className="icon"><span className="icon-comment"></span></div>
                    <div className="text"><p>Join our mission</p></div>
                  </div>
                  <p className="about-page__points-text">Volunteer, partner or advocate with Rayyan Aid to extend compassion where it’s needed most.</p>
                </li>
                <li>
                  <div className="about-page__points-content">
                    <div className="icon"><span className="icon-comment"></span></div>
                    <div className="text"><p>Transparent fundraising</p></div>
                  </div>
                  <p className="about-page__points-text">Every donation is tracked to programs with clear goals, reports and measurable outcomes.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;
